import { styled } from "styled-components";

import { triggerLogin } from "authentication/actions";
import { UIButton } from "common/components";
import { breakpoints } from "common/styles";
import { useDispatch } from "common/utilities/react-redux";
import { useTrack } from "common/utilities/useTrack";
import { useTranslate } from "common/utilities/useTranslate";
import { useWeforumUrl } from "common/utilities/useWeforumUrl";
import type { TrackEvent } from "domains/analytics/types";

const StyledButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;

  @media ${breakpoints.medium} {
    flex-direction: row;
    margin-bottom: 7rem;
    width: auto;
  }
`;

export const AuthButtons = () => {
  const dispatch = useDispatch();
  const track = useTrack();
  const translate = useTranslate();
  const weforumUrl = useWeforumUrl();

  const onClickSignIn = (name: TrackEvent) => () => {
    track({ name, eventType: "initialize modal" });
    dispatch(triggerLogin());
  };

  return (
    <StyledButtonContainer>
      <UIButton as="a" href={`${weforumUrl}/join-us`} icon="rightArrow" variant="filled">
        {translate("app.registration.join_us")}
      </UIButton>
      <UIButton icon="rightArrow" onClick={onClickSignIn("Login")} variant="outlined">
        {translate("app.user.sign_in")}
      </UIButton>
    </StyledButtonContainer>
  );
};
